import { axiosStudentInstance } from "./studentAuth"
import type { HierarchyItemDto, StudentSubject } from "../page/Student/Questions/types"

interface Envelope<T> {
  success: boolean
  status_code: number
  message: string
  data: T
}

const HIERARCHY_MAX_PAGE_SIZE = 100

export interface StudentHierarchyListParams {
  level: number
  parent_id?: string | null
  level_1_id?: string | null
  level_2_id?: string | null
  level_3_id?: string | null
  search?: string
  page?: number
  limit?: number
}

export const listStudentSubjects = () =>
  axiosStudentInstance.get<Envelope<StudentSubject[]>>("/subjects/")

export const getStudentSubject = (subjectId: string) =>
  axiosStudentInstance.get<Envelope<StudentSubject>>(`/subjects/${subjectId}`)

export const listStudentHierarchyItems = (
  subjectId: string,
  params: StudentHierarchyListParams
) => {
  const query: Record<string, string | number> = { level: params.level }
  if (params.parent_id) query.parent_id = params.parent_id
  if (params.level_1_id) query.level_1_id = params.level_1_id
  if (params.level_2_id) query.level_2_id = params.level_2_id
  if (params.level_3_id) query.level_3_id = params.level_3_id
  if (params.search) query.search = params.search
  query.page = params.page ?? 1
  query.limit = params.limit ?? HIERARCHY_MAX_PAGE_SIZE

  return axiosStudentInstance.get<
    Envelope<{
      items: HierarchyItemDto[]
      total: number
      page: number
      limit: number
      total_pages: number
      level: number
    }>
  >(`/subjects/${subjectId}/hierarchy/items`, { params: query })
}

/** Pages through hierarchy items at API max (100), same as teacher helper. */
export const listAllStudentHierarchyItems = async (
  subjectId: string,
  params: Omit<StudentHierarchyListParams, "page" | "limit">
): Promise<HierarchyItemDto[]> => {
  const items: HierarchyItemDto[] = []
  let page = 1
  let totalPages = 1

  while (page <= totalPages) {
    const response = await listStudentHierarchyItems(subjectId, {
      ...params,
      page,
      limit: HIERARCHY_MAX_PAGE_SIZE,
    })
    const data = response?.data?.data
    items.push(...(data?.items || []))
    totalPages = data?.total_pages ?? 1
    page += 1
  }

  return items
}
